import { VirtualList } from '@epam/promo';
import { resetDraft, setDraftTask, useTaskStore } from 'store/task.store';
import { useScroll } from 'hooks/ui/useScroll';
import { Task } from 'models/task.model';
import { useModal, useTaskDeleteQuery, useTaskSwitcher } from 'hooks';
import { Card } from '../Card';
import css from './CardList.module.scss';
import { useNavigate } from 'react-router-dom';

export const CardList = ({ items }: { items: Task[] }) => {
  const navigate = useNavigate();
  const switchTask = useTaskSwitcher();
  const modal = useModal();
  const draftTask = useTaskStore((state) => state.draft);
  const { value, setValue } = useScroll();
  const { mutate: deleteTask } = useTaskDeleteQuery();

  return (
    <VirtualList
      cx={`${css.list} ${css.taskInput__container}`}
      rows={
        items.map((item) => (
          <Card
            key={item.id}
            isActive={item.id === draftTask?.id}
            item={item}
            onClick={() =>
              switchTask({
                onSuccess: () => {
                  resetDraft();
                  setDraftTask(item);
                  navigate(`/tasks/${item.id}`);
                },
                onAbort: () => navigate(`/tasks/${item.id}`),
              })
            }
            onDelete={() =>
              modal.delete({
                text: `Are you sure you want to delete ${item.title}?`,
                highlight: item.title,
                onSuccess: () => deleteTask({ id: item.id }),
              })
            }
          />
        )) || []
      }
      rowsCount={items.length}
      value={value}
      onValueChange={setValue}
    />
  );
};
